(function($) {  

  let $shortcodeLC = $('.ShortCode.ListCourses')
  if($shortcodeLC.length) { 

    $courses = $shortcodeLC.find('.Courses')
    $course = $courses.find('.Course')

    const $titleexcerptwrappers = $course.find('.TitleExcerptWrapper')
    .on(
      'mouseenter',
      function() {

        const $wrapper = $(this)
        const wrapperheight = $wrapper.height()
        const $titleexcerpt = $wrapper.find('.TitleExcerpt')
        const titleexcerptheight = $titleexcerpt.height();
        const scroll = wrapperheight - titleexcerptheight - 20
        
        if(scroll < 0) {
          
          $titleexcerpt.css('top', scroll + 'px')
        }
      }
    )
    .on(
      'mouseleave',
      function() {

        const $wrapper = $(this)
        const $titleexcerpt = $wrapper.find('.TitleExcerpt')

        $titleexcerpt.css('top', '0px')
      }
    )
  }

  let $shortcodeICP = $('.InCoursesPage')
  if($shortcodeICP.length) { 

    $shortcodeICP = $shortcodeICP.eq(0)
    $courseslist = $shortcodeICP.find('.ShortCode.ListCourses').eq(0)
    $orderselector = $courseslist.find('.Query .Order .Selector').eq(0)
    $courses = $shortcodeICP.find('.Courses').eq(0)
    $course = $courses.find('.Course')

    const sort = (data) => {

      const $coursesforsort = $course.detach()

      $courses.append(
        $coursesforsort
        .toArray()
        .sort(
          function(a, b){

            const aVal = parseFloat(a.getAttribute(data))
            const bVal = parseFloat(b.getAttribute(data))

            return data == 'data-order' ?  aVal - bVal : bVal - aVal
          }
        )
      )
    }

    $orderselector
    .on(
      'change',
      function() {

        const $this = $(this)
        sort($this.val())
      }
    )

    sort($orderselector.val())
  }

})(jQuery)